import { Component, Input, OnInit } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import { ReportModel } from 'src/app/Models/report-model';

@Component({
  selector: 'ze-progress-loader',
  templateUrl: './progress-loader.component.html',
  styleUrls: ['./progress-loader.component.scss'],
})
export class ProgressLoaderComponent implements OnInit {

  @Input("reportModel") reportModel: ReportModel;

  progressBarValue: number = 0;
  currentMessage: string = "Checking for Status...";
  showInfo: boolean[] = [false, false, false, false, false, false]; // Array to track the visibility of each li
  private intervalSubscription: Subscription;

  timeoutId: any;

  constructor() { }

  ngOnInit(): void {
    this.updateProgress();

    if (this.reportModel.run_status_text == null) {
      this.startInterval();
    }
  }

  ngOnDestroy() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe(); // Unsubscribe from the interval to prevent memory leaks
    }
  }

  ngOnChanges() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }

    if (this.reportModel.run_status_text == null) {
      this.startInterval();
    }

    this.updateProgress();
  }

  startInterval() {
    this.intervalSubscription = interval(5000).subscribe(() => {
      this.updateProgress();
    });
    this.updateProgress();
  }

  updateProgress() {
    if (this.reportModel.run_status_text == null) {
      const currentTime = new Date().getTime();
      let startTime = +this.reportModel.start_time;
      const elapsedTime = (currentTime - startTime)/1000;
      this.setShowInfo();
      if (elapsedTime < 10) {
        this.currentMessage = "Prioritizing Requests...";
        this.progressBarValue = 5;
      } else if (elapsedTime < 30) {
        this.currentMessage = "Resource Allocation in Progress...";
        this.progressBarValue = 20;
      } else if (elapsedTime < 60) {
        this.currentMessage = "Infrastructure Setup in Progress...";
        this.progressBarValue = 40;
      } else if (elapsedTime < 90) {
        this.currentMessage = "Infrastructure is Almost Ready, Waiting for Available Resources...";
        this.progressBarValue = 60;
      } else if (elapsedTime >= 90) {
        this.currentMessage = "Waiting for Available Resources...";
        this.progressBarValue = 70;
      }
    } else {
      if (this.intervalSubscription) {
        this.intervalSubscription.unsubscribe();
      }
      if (this.reportModel.run_status_text == "GENERATING_CODE") {
        this.setShowInfo();
        this.currentMessage = "Creating Framework...";
        this.progressBarValue = 75;
      } else if (this.reportModel.run_status_text == "STITCH_FRAMEWORK") {
        this.setShowInfo();
        this.currentMessage = "Integrating Framework Modules...";
        this.progressBarValue = 90;
      } else if (this.reportModel.run_status_text == "DEPLOY_FRAMEWORK") {
        this.setShowInfo();
        this.currentMessage = "Configuring Deployment Settings...";
        this.progressBarValue = 95;
      }
      else if (this.reportModel.run_status_text == "EXECUTE_FRAMEWORK") {
        this.setShowInfo();
        this.currentMessage = "Waiting for Execution to Start...";
        this.progressBarValue = 99;
      }
    }
  }

  setShowInfo() {
    this.showInfo[0] = true;
    this.showInfo[1] = true;
    this.showInfo[2] = true;
  }

  getDelayInSeconds(): string {
    if (this.reportModel && this.reportModel.default_pause !== undefined) {
      const defaultPauseInSeconds = parseInt(this.reportModel.default_pause) / 1000;
      return defaultPauseInSeconds.toString() + ' seconds';
    } else {
      return '0 seconds';
    }
  }
}
